const { getGenderFromFilename } = window.BAO.Utils

class ProductMediaStacked extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.unisexProduct) return

    if (window.innerWidth >= 768) {
      this.els.media.elements[0]
        .querySelector('img.rsp-Image_Image')
        .removeAttribute('loading')
    }

    const url = new URL(window.location)
    const gender =
      (url.searchParams.has('gender') && url.searchParams.get('gender')) ||
      sessionStorage.getItem('gender') ||
      'female'
    this.setGenderBasedMedia(gender)
    this.setGenderCartAttribute(gender)

    this.els.wrapper.element.style.opacity = '1'
  }

  setGenderBasedMedia (gender) {
    if (!['male', 'female'].includes(gender)) {
      return
    }

    const oppositeGender = gender === 'male' ? 'female' : 'male'
    const media = this.els.media.elements

    // Remove opposite gender media, keeping original order
    media.forEach(slide => {
      const el = slide.querySelector('img, lazy-video')
      if (!el) return
      const src =
        el.tagName === 'IMG' ? el.src : el.querySelector('source')?.dataset?.src
      if (getGenderFromFilename(src) === oppositeGender) {
        slide.remove()
      }
    })
  }

  setGenderCartAttribute (gender) {
    sessionStorage.setItem('gender', gender)
    window.BAO.Cart.updateCartAttributes({ gender })
  }

  get unisexProduct () {
    const { productGender } = this.dataset
    return productGender === 'unisex'
  }
}

if (!customElements.get('')) {
  customElements.define('product-media-stacked', ProductMediaStacked)
}
